"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeColumnsOrder = void 0;
const ramda_1 = require("ramda");
const mergeColumnsOrder = (currentFields, columnsOrder) => {
    const nextOrder = (0, ramda_1.intersection)(columnsOrder, currentFields);
    const missingFields = (0, ramda_1.without)(nextOrder, currentFields);
    missingFields.forEach((missingField) => {
        const currentIndex = currentFields.indexOf(missingField);
        const previousField = currentFields
            .slice(0, currentIndex)
            .reverse()
            .find((field) => nextOrder.includes(field));
        const nextField = currentFields
            .slice(currentIndex + 1)
            .find((field) => nextOrder.includes(field));
        if (previousField && nextField) {
            const previousIndex = nextOrder.indexOf(previousField);
            const nextIndex = nextOrder.indexOf(nextField);
            if (previousIndex < nextIndex) {
                nextOrder.splice(nextIndex, 0, missingField);
                return;
            }
            nextOrder.push(missingField);
            return;
        }
        if (nextField) {
            nextOrder.splice(nextOrder.indexOf(nextField), 0, missingField);
            return;
        }
        nextOrder.push(missingField);
    });
    return nextOrder;
};
exports.mergeColumnsOrder = mergeColumnsOrder;
